import { SegmentTrack } from '@enums/segment'
import { SUBMISSION_ERR } from '@enums/form-submission-error'
import { ignoreCypress } from '@util/ignore-cypress'
import { segmentTrack } from './track'

type AdditionalProperties = {
  errorCode?: SUBMISSION_ERR
  // snakecased for Segment
  company_id?: string
}

type SegmentTrackApi = {
  (
    event:
      | SegmentTrack.signUp
      | SegmentTrack.signIn
      | SegmentTrack.resetPassword,
    success: boolean,
    // additional properties that can be appended to the tracking call
    additionalProperties: AdditionalProperties
  ): void
}

const segmentTrackApi: SegmentTrackApi = (
  event,
  success,
  additionalProperties
) => {
  const formattedProperties = success
    ? { success, ...additionalProperties }
    : { success, reason: additionalProperties.errorCode }

  segmentTrack(event, formattedProperties)
}

export const trackApi = ignoreCypress(segmentTrackApi)
